import { useQuery } from '@tanstack/react-query';
import { fetchAllTeacherClassRooms } from '../api/teachers';
const useFetchTeacherAllClassrooms = (userId) => {
  return useQuery({
    queryKey: ['fetchingTeacherAllClassrooms', userId],
    queryFn: async () => {
      if (!userId) return [];
      const fetchedData = await fetchAllTeacherClassRooms(userId);

      return (
        fetchedData?.schoolClassrooms?.map((classroom) => ({
          classroomId: classroom?.classroomId,
          classroomName: classroom?.classroomName || '',
          primaryTeacherId: classroom?.primaryTeacher?.teacherId,
          primaryTeacher: classroom.primaryTeacher?.fullname || '',
          primaryTeacherEmail: classroom.primaryTeacher?.email || '',
          primaryTeacherPhotoURL: classroom.primaryTeacher?.photoURL || null,
          primaryTeacherStudents:
          // eslint-disable-next-line no-self-compare
          classroom?.primaryTeacher?.teacherId === classroom?.primaryTeacher?.teacherId
            ? (classroom?.allStudents || [])
                .filter((student) => {
                  const isSecondaryStudent = classroom?.secondaryTeachers?.some((sec) =>
                    (sec.students || []).some(
                      (s) =>
                        s?.id === student?.id ||
                        s?.studentId === student?.studentId
                    )
                  );
                  return !isSecondaryStudent;
                })
                .map((student) => ({
                  id: student?.id || student?.studentId,
                  name: student?.fullname || '',
                  email: student?.email,
                  parentName: student?.parentName || '',
                  photoURL: student?.photoURL || null,
                }))
            : [],
          studentIds:
            classroom?.allStudents?.map(
              (student) => student?.id || student?.studentId
            ) || [],

          secondaryTeachersandStudent: classroom?.secondaryTeachers?.map(
            (secondary) => ({
              secondaryTeacherId: secondary?.teacher?.teacherId,
              secondaryTeacherName: secondary?.teacher?.fullname || '',
              secondaryTeacherEmail: secondary?.teacher?.email || '',
              secondaryTeacherPhotoURL: secondary?.teacher?.photoURL || null,
              students:
                secondary?.students?.map((student) => ({
                  id: student?.id || student?.studentId,
                  name: student?.fullname || '',
                  email: student?.email,
                  parentName: student?.parentName || '',
                  photoURL: student?.photoURL || null,
                })) || [],
            })
          ),
          schoolId: classroom.schoolId,
          schoolName: classroom.schoolName || '',
          photoURL: classroom.photoURL || null,
        })) || []
      );
    },
    staleTime: 60000, // 1 min
    cacheTime: 300000, // 5 min
  });
};
export default useFetchTeacherAllClassrooms;
